<script setup lang="ts">
import { useId } from 'vue'
import { useI18n } from 'vue-i18n'

import { useDesktopAvatarNotice } from '../composables/useDesktopAvatarNotice'
import { StButton, StDialog } from './studio'

const { t } = useI18n()
const { open, close } = useDesktopAvatarNotice()
const descriptionId = useId()
</script>

<template>
  <div v-if="open" class="studio-ui">
    <StDialog :title="t('avatars.desktopOnly.title')" :aria-describedby="descriptionId" @close="close">
      <p :id="descriptionId" class="modal-intro">
        {{ t('avatars.desktopOnly.description') }}
      </p>
      <footer class="modal-actions">
        <StButton variant="primary" @click="close">
          {{ t('avatars.desktopOnly.confirm') }}
        </StButton>
      </footer>
    </StDialog>
  </div>
</template>
